import { IServerSideGetRowsRequest } from '@samc/centricity-core';
import { orderBy, orderByDescending, isNullOrUndefined } from '@samc/common';

export function processAgGridRequest<T extends object>(data: T[], request: IServerSideGetRowsRequest): T[] {
  let results = [...data];
  if (request.sortModel && request.sortModel.length > 0) {
    // TODO: Build out mulit-sorting
    const colId = request.sortModel[0].colId as keyof T;
    results = request.sortModel[0].sort === 'asc' ?
      orderBy(results, x => x[colId]) :
      orderByDescending(results, x => x[colId] ?? null);
  }

  if (request.filterModel) {
    const keys = Object.keys(request.filterModel);
    for (let i = 0; i < keys.length && results.length > 0; ++i) {
      const colId = keys[i] as keyof T;

      results = results.filter(x => {
        if (isNullOrUndefined(x[colId])) return false;

        // @ts-ignore
        switch (request.filterModel[keys[i]].type) {
          // @ts-ignore
          case 'equals': return x[colId] === request.filterModel[keys[i]].filter;
          // @ts-ignore
          case 'contains': return (x as any)[colId].toString().toLowerCase().indexOf(request.filterModel[keys[i]].filter.toString().toLowerCase()) > -1;
        }
        return true;
      });
    }
  }

  return results
    .slice(request.startRow ?? 0, (request.endRow ?? (results.length - 1)) + 1);
}
